import React from 'react';
import Icon from '../../../components/AppIcon';

const TechnologyEvolution = ({ techData }) => {
  return (
    <div className="bg-white rounded-xl shadow-premium border border-border p-6">
      <div className="flex items-center mb-6">
        <Icon name="Layers" size={24} className="text-accent mr-3" />
        <h3 className="text-xl font-semibold text-text-primary">Technology Stack Evolution</h3>
      </div>

      <div className="space-y-8">
        {techData.map((category, index) => (
          <div key={index}>
            <h4 className="font-semibold text-text-primary mb-4 flex items-center">
              <Icon name={category.icon} size={18} className="mr-2 text-primary" />
              {category.category}
            </h4>
            
            <div className="space-y-3">
              {category.timeline.map((period, periodIdx) => (
                <div key={periodIdx} className="flex items-center space-x-4">
                  <div className="w-16 text-sm font-medium text-text-secondary">
                    {period.year}
                  </div>
                  <div className="flex-1">
                    <div className="flex flex-wrap gap-2">
                      {period.technologies.map((tech, techIdx) => (
                        <span 
                          key={techIdx}
                          className={`px-3 py-1 rounded-full text-sm font-medium ${
                            tech.status === 'current' ?'bg-success/10 text-success border border-success/20'
                              : tech.status === 'learning' ?'bg-warning/10 text-warning border border-warning/20' :'bg-surface text-text-muted border border-border'
                          }`}
                        >
                          {tech.name}
                          {tech.status === 'current' && (
                            <Icon name="CheckCircle" size={12} className="ml-1 inline" />
                          )}
                          {tech.status === 'learning' && (
                            <Icon name="Clock" size={12} className="ml-1 inline" />
                          )}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Legend */}
      <div className="mt-6 pt-6 border-t border-border">
        <div className="flex flex-wrap gap-4 text-sm">
          <div className="flex items-center">
            <div className="w-3 h-3 bg-success/20 border border-success/40 rounded-full mr-2"></div>
            <span className="text-text-secondary">Currently Using</span>
          </div>
          <div className="flex items-center">
            <div className="w-3 h-3 bg-warning/20 border border-warning/40 rounded-full mr-2"></div>
            <span className="text-text-secondary">Learning/Exploring</span>
          </div>
          <div className="flex items-center">
            <div className="w-3 h-3 bg-surface border border-border rounded-full mr-2"></div>
            <span className="text-text-secondary">Previously Used</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechnologyEvolution;